import { CommonGet, CommonPost } from "../../../utils/CommonFetch";
import tokenDecoder from '../../../components/Common/tokenDecoder';

export default {
    GetSupplierDetails,
    GetCollectionPointsFilter,
    saveSupplier,
    updateSupplier,
    SaveEmployeeBiometrics,
    GetCollectionPointsByCpCategoryandOpEntity,
    GetSupplierByID,
    getMultiCropsByGroupID,
    GetCollectionCategoryByOperationEntityID,
    GetCollectionPointByoperationEntityID,
    GetCollectionTypeByCollectionPoint,
    GetSupplierCollectionTypes,
    GetCollectionTypeByCollectionPointForSearcahbleDropDown
};

async function GetCollectionPointsFilter(id) {
    var collectionPointArray = [];
    var response = await CommonGet('/api/Card/GetCollectionPointsFilter', null);
    for (let item of Object.entries(response.data)) {
        if (item[1] !== undefined && item[1]["operationEntityID"] === parseInt(id))
            collectionPointArray[item[1]["collectionPointID"]] = item[1]["collectionPointName"];
    }
    return collectionPointArray;
}

async function saveSupplier(supplierInformation) {
    supplierInformation.createdBy = parseInt(tokenDecoder.getUserIDFromToken());
    supplierInformation.createdDate = new Date().toISOString();
    const response = await CommonPost('/api/ExportSupplier/SaveSupplier', null, supplierInformation);
    return response;
}

async function updateSupplier(supplierInformation) {
    supplierInformation.modifiedBy = parseInt(tokenDecoder.getUserIDFromToken());
    supplierInformation.modifiedDate = new Date().toISOString();
    const response = await CommonPost('/api/ExportSupplier/UpdateSupplier', null, supplierInformation);
    return response;
}

async function SaveEmployeeBiometrics(pictures, employeeID, isDefault) {
    let employeeBiometrics = {
        employeeID: employeeID,
        employeeBiometricData: pictures,
        employeeBiometricDataTypeID: 1,
        isDefault: isDefault,
        isActive: true,
        CreatedBy: 0,
        CreatedDate: new Date().toISOString(),
        modifiedBy: 0,
        ModifiedDate: new Date().toISOString(),
    }
    const response = await CommonPost('/api/EmployeeBiometrics/SaveEmployeeBiometrics', null, employeeBiometrics);
    return response;
}

async function GetCollectionPointsByCpCategoryandOpEntity(operationEntityID, collectionPointCategoryID) {
    var collectionPointArray = [];
    var response = await CommonGet('/api/CollectionPoint/GetCollectionPointsByCpCategoryandOpEntity', 'operationEntityID=' + operationEntityID + '&collectionPointCategoryID=' + collectionPointCategoryID);
    for (let item of Object.entries(response.data)) {
        collectionPointArray[item[1]["collectionPointID"]] = item[1]["collectionPointName"];
    }
    return collectionPointArray;
}

async function GetSupplierDetails(supplier) {
    supplier.groupID = supplier.groupID.toString();
    supplier.operationEntityID = supplier.operationEntityID.toString();

    const response = await CommonPost('/api/ExportSupplier/GetSupplierDetails', null, supplier);
    return response.data;
}

async function getMultiCropsByGroupID(id) {
    var operationEntityArray = [];

    if (id.toString() === '0')
        return operationEntityArray;

    var response = await CommonGet('/api/OperationEntity/GetMultiCropsByGroupID', 'groupID=' + id);
    for (let item of Object.entries(response.data)) {
        operationEntityArray[item[1]["operationEntityID"]] = item[1]["operationEntityName"];
    }
    return operationEntityArray;
}

async function GetCollectionCategoryByOperationEntityID(id) {
    var collectionCategory = [];

    if (id.toString() === '0')
        return collectionCategory;

    var response = await CommonGet('/api/CollectionCategory/GetCollectionCategoryByOperationEntityID', 'operationEntityID=' + id);
    for (let item of Object.entries(response.data)) {
        collectionCategory[item[1]["collectionCategoryID"]] = item[1]["collectionCategoryName"];
    }
    return collectionCategory;
}

async function GetCollectionPointByoperationEntityID(id) {
    var collectionPointArray = [];

    if (id.toString() === '0')
        return collectionPointArray;

    var response = await CommonGet('/api/CollectionPoint/GetCollectionPointByoperationEntityID', 'operationEntityID=' + id);
    for (let item of Object.entries(response.data)) {
        collectionPointArray[item[1]["collectionPointID"]] = item[1]["collectionPointName"];
    }
    return collectionPointArray;
}

async function GetCollectionTypeByCollectionPoint(id) {
    var productsArray = [];

    if (id.toString() === '0')
        return productsArray;

    var response = await CommonGet('/api/CollectionType/GetCollectionTypeByCollectionPoint', 'id=' + id);
    for (let item of Object.entries(response.data)) {
        productsArray[item[1]["collectionTypeID"]] = item[1]["collectionTypeName"];
    }
    return productsArray;
}

async function GetSupplierByID(id) {
    var response = await CommonGet('/api/ExportSupplier/GetSupplierByID', 'id=' + id);
    return response.data;
}

async function GetSupplierCollectionTypes(id) {
    var response = await CommonGet('/api/ExportSupplier/GetSupplierCollectionTypes', 'id=' + id);
    return response.data;
}

async function GetCollectionTypeByCollectionPointForSearcahbleDropDown(id) {
    var productsArray = [];

    if (id.toString() === '0')
        return productsArray;

    var response = await CommonGet('/api/CollectionType/GetCollectionTypeByCollectionPoint', 'id=' + id);
    return response.data;
}